/** @jsx jsx */
import { css, jsx } from "@emotion/react"
import MediaProvider from "components/common/Context/MediaContext"
import { useTheme } from "components/common/Context/ThemeContext"
import PropTypes from "prop-types"
import React from "react"
const CMSTabs = ({
  tabs = [],
  onChange,
  selectedTab,
  type = "floating",
  isPopupTab = false,
  minWidth
}) => {
  const theme = useTheme()
  const { isSmallScreen } = React.useContext(MediaProvider)
  const useStyles = (theme) => {
    return {
      fixedTabContainer: css`
        display: flex;
      `,
      floatingTabContainer: css`
        display: flex;
        flex-flow: wrap;
        & > :first-of-type {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        & > :last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      `,
      tabBtn: css`
        display: flex;
        align-items: center;
        justify-content: center;
        height: 2.1875rem;
        padding: 5px 10px;
        border: 0;
      `,
      fixedTabBtn: css`
        font-size: 0.75rem;
        min-width: ${isSmallScreen ? 6 : minWidth || 14.25}rem;
        border-radius: 4px 4px 0 0;
        margin-right: 0.5rem;
      `,
      floatingTabBtn: css`
        font-size: 0.875rem;
        min-width: 5.675rem;
        border-radius: 0;
        white-space: nowrap;
        padding: 5px 10px;
        border: 0;
      `,
      inactiveBtn: css`
        background-color: ${theme.tabBtnColor};
        color: ${theme.tabTextColor};
        font-family: ${theme.fontFamilyRegular};
        &:focus,
        &:hover {
          background-color: ${theme.tabBtnHoverColor};
          outline: none;
        }
      `,
      activeBtn: css`
        font-weight: 600;
        background-color: ${theme.primaryTextColor};
        color: ${theme.cancelBtnBg};
        font-family: ${theme.fontFamilyMedium};
        &:focus,
        &:hover {
          background-color: ${theme.tabBtnActiveHoverColor};
          outline: none;
        }
      `,
      inactiveTab: css`
        background-color: #f3fcf2;
        color: ${theme.tabTextColor};
        font-family: ${theme.fontFamilyRegular};
        &:focus,
        &:hover {
          background-color: #f3fcf2;
          outline: none;
        }
      `,
      activeTab: css`
        font-weight: 600;
        background-color: #fff;
        color: ${theme.btnBgPrimaryColor};
        font-family: ${theme.fontFamilyMedium};
        &:focus,
        &:hover {
          background-color: #fff;
          outline: none;
        }
      `
    }
  }

  const classes = useStyles(theme)

  return (
    <div
      css={
        type === "fixed"
          ? classes.fixedTabContainer
          : classes.floatingTabContainer
      }
    >
      {tabs.map(({ text, key }) => (
        <button
          key={key}
          onClick={() => onChange(key)}
          css={[
            classes.tabBtn,
            type === "fixed" ? classes.fixedTabBtn : classes.floatingTabBtn,
            key === selectedTab
              ? isPopupTab
                ? classes.activeTab
                : classes.activeBtn
              : isPopupTab
              ? classes.inactiveTab
              : classes.inactiveBtn
          ]}
        >
          {text}
        </button>
      ))}
    </div>
  )
}
export default CMSTabs

CMSTabs.propTypes = {
  tabs: PropTypes.array,
  type: PropTypes.string,
  onChange: PropTypes.func,
  selectedTab: PropTypes.string,
  minWidth: PropTypes.number,
  isPopupTab: PropTypes.bool
}
